<template>
  <div class="l-step-content-box" v-loading="loading" style="width:600px">
    <el-form :model="form_data" label-width="200px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-form-item label="企业名称" prop="name">
        <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入企业名称"></el-input>
      </el-form-item>
      <el-form-item label="企业简称" prop="short_name">
        <el-input v-model="form_data.short_name" autocomplete="off" placeholder="请输入企业简称"></el-input>
      </el-form-item>

      <el-form-item label="权限模块" prop="module_ids">
        <el-checkbox-group v-model="form_data.module_ids">
          <el-checkbox v-for="item in module_list" :label="item.id" :key="item.id">{{
            item.name
          }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="注册是否强制填写营业厅" prop="is_force_hall">
        <el-radio-group v-model="form_data.is_force_hall">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="报修是否强制填写设备编码" prop="is_force_dev_code">
        <el-radio-group v-model="form_data.is_force_dev_code">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="" style="margin-top: 20px">
        <el-button type="primary" :loading="submitting" @click="handleSubmit">下一步</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
  name: "l-company-add-step1",
  props: {
    companyName: {
      type: String,
      default: "",
    },

    reviewId: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      loading: false,

      module_list: [],
      //表单数据
      submitting: false,
      form_data: {
        id: "",
        name: "",
        short_name: "",
        company_apply_id: "",
        module_ids: [],
        is_force_hall: 0,
        is_force_dev_code: 0,
      },

      rules: {
        name: [
          { required: true, message: "请输入企业名称", trigger: "change" },
        ],
        short_name: [
          { required: true, message: "请输入企业简称", trigger: "change" },
        ],
        module_ids: [
          {
            type: "array",
            required: true,
            message: "请输入选择权限模块",
            trigger: "change",
          },
        ],
        is_force_hall: [
          {
            type: "number",
            required: true,
            message: "注册是否需要填写营业厅",
            trigger: "change",
          },
        ],

        is_force_dev_code: [
          {
            type: "number",
            required: true,
            message: "报修是否强制填写设备编码",
            trigger: "change",
          },
        ],
      },
    };
  },

  mounted() {
    this.form_data.name = this.$props.companyName;
    this.form_data.company_apply_id = this.$props.reviewId;
    this.getData();
  },

  methods: {
    //查数据
    getData() {
      this.loading = true;
      this.$_invoke("company_getAddData", this.form_data).then((ret) => {
        this.loading = false;
        this.module_list = ret.module_list;
        this.$nextTick(() => {
          this.module_list.forEach((item) => {
            this.form_data.module_ids.push(item.id);
          });
        });
      });
    },
    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {
            //添加
            this.$_invoke("org_saveCompany", this.form_data)
              .then((ret) => {
                this.form_data.id = ret;
                this.$_msg.success("保存企业基础信息成功");
                this.$emit("on-success", ret);
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            //   this.$_invoke(`org_update`, form_data).then(() => {
            //     this.$_msg.success('修改成功');
            //     this.$emit('on-success');
            //   }).finally(() => {
            //     this.submitting = false;
            //   })
          }
        }
      });
    },
  },
};
</script>
